import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../styles/Header.scss';
import logo from '../../assets/images/logo_concept.png';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import { Button } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';

const Header = ({ className , children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [user, setUser] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
      setIsOpen(!isOpen);
      if (!isOpen) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
  };

  const handleLogout = async () => {
    await signOut(auth);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    // Clean up the no-scroll class when the component unmounts or page changes
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      const parallax = document.querySelector('.parallax');
      const scrollPosition = window.pageYOffset;
      parallax.style.backgroundPositionY = `${scrollPosition * 0.5}px`; // Adjust this value for different speeds
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <header className={`header parallax ${className}`}>
      <div className='header-topbar'>
        <div className="header__logo">
            <Link to="/">
                <img src={logo} alt="Logo" />
            </Link>
        </div>
        <nav className={`header__nav ${isOpen ? 'header__nav--open' : ''}`}>
            <ul>
                <li><Link to="/" onClick={toggleMenu}>Home</Link></li>
                <li><Link to="/menu" onClick={toggleMenu}>Menù</Link></li>
                <li><Link to="/about" onClick={toggleMenu}>Chi Siamo</Link></li>
                { user && (
                  <>
                    <li><Link to="/admin" onClick={toggleMenu}>Amministrazione</Link></li>
                    <li><Button className="logout-button" onClick={handleLogout} startIcon={<LogoutIcon/>}>Logout</Button></li>
                  </>
                )}
                {/* <li><Link to="/admin" onClick={toggleMenu}>Admin</Link></li> */}
            </ul>
        </nav>
        <div className="header__menu-icon" onClick={toggleMenu}>
            <div className={`bar ${isOpen ? 'bar--open' : ''}`}></div>
            <div className={`bar ${isOpen ? 'bar--open' : ''}`}></div>
            <div className={`bar ${isOpen ? 'bar--open' : ''}`}></div>
        </div>
      </div>
      {children}
    </header>
  );
};

export default Header;
